export default "__VITE_ASSET__BpzTBBci__"